"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _reactDom = require("react-dom");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\toverflow-x: visible;\n\t\t\toverflow-y: visible;\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: white;\n\tposition: relative;\n\twidth: ", ";\n\tanimation: ", " 0.3s ease-in-out 0s;\n\tbox-shadow: ", ";\n\tmargin: ", ";\n\tborder-radius: ", ";\n\tmax-height: 90%;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\t", ";\n\n\t", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\t", ";\n\twidth: 100%;\n\tz-index: 9998;\n\tbackground: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tfrom {\n\t\topacity: 0;\n\t}\n\tto {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var MODAL_WIDTHS = _vars.default.modalWidths;
var fadeIn = (0, _styledComponents.keyframes)(_templateObject());

var Background = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.version === '1' && 'height: 100vh';
}, _colors.default.modalOverlay);

var ModalContainer = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.width;
}, fadeIn, _vars.default.boxShadow, _spacing.default.s2, _vars.default.borderRadius, function (props) {
  return props.version === '1' && '-webkit-overflow-scrolling: touch';
}, function (props) {
  return props.allowOverflow && (0, _styledComponents.css)(_templateObject4());
});

ModalContainer.displayName = 'ModalContainer';
Background.displayName = 'Background';

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* istanbul ignore next */
    if (this.props.version === '1') {
      // eslint-disable-next-line no-console
      console.warn('Please upgrade <Modal /> to version 2');
    }

    document.body.style.overflow = 'hidden';
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.style.overflow = 'auto';
  };

  _proto.render = function render() {
    var _this$props = this.props,
        close = _this$props.close,
        children = _this$props.children,
        bgDismiss = _this$props.bgDismiss,
        width = _this$props.width,
        allowOverflow = _this$props.allowOverflow,
        version = _this$props.version,
        rest = _objectWithoutPropertiesLoose(_this$props, ["close", "children", "bgDismiss", "width", "allowOverflow", "version"]);

    var modalWidth = (0, _lodash.default)(MODAL_WIDTHS, width, width);

    var dismiss = function dismiss() {
      if (bgDismiss) {
        close();
      }
    };

    return (0, _reactDom.createPortal)(_react.default.createElement(Background, _extends({
      onClick: dismiss,
      version: version
    }, rest, {
      "data-testid": "background"
    }), _react.default.createElement(ModalContainer, {
      width: modalWidth,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      allowOverflow: allowOverflow,
      version: version,
      role: "region"
    }, _react.default.Children.map(children, function (child) {
      if (!child) {
        return null;
      }

      return _react.default.cloneElement(child, {
        close: close
      });
    }))), document.body);
  };

  return Modal;
}(_react.default.Component);

Modal.displayName = 'Modal';
Modal.propTypes = {
  children: _propTypes.node,

  /** small: 450px, medium: 600px, large: 800px, or custom string e.g: '777px' */
  width: _propTypes.string,
  bgDismiss: _propTypes.bool,
  close: _propTypes.func,
  allowOverflow: _propTypes.bool,
  version: (0, _propTypes.oneOf)(['1', '2'])
};
Modal.defaultProps = {
  children: null,
  bgDismiss: true,
  width: 'small',
  close: function close() {},
  allowOverflow: false,
  version: '1'
};
var _default = Modal;
exports.default = _default;